import { render } from "./Activate.vue?vue&type=template&id=7ac0f5a4&scoped=true"
import script from "./Activate.vue?vue&type=script&lang=js"
export * from "./Activate.vue?vue&type=script&lang=js"

import "./Activate.vue?vue&type=style&index=0&id=7ac0f5a4&scoped=true&lang=css"

import exportComponent from "/webserver/websites/dev/intrapaf-v2-public-client-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ac0f5a4"]])

export default __exports__